import React from "react";
import "./Accreditations.css";

import cert1 from "../../../assets/thumbnails/incorCertificate.jpg"; // Incorporation Certificate
import cert2 from "../../../assets/thumbnails/startupcert.jpg"; // Startup Certificate
import cert3 from "../../../assets/thumbnails/iso01.jpg"; // ISO Certificate
import cert4 from "../../../assets/thumbnails/iso2.jpg"; // ERTP Certificate
// import cert4 from "../../../assets/thumbnails/iso2.jpg"; // ERTP Certificate

function Accreditations() {
  const cards = [
    {
      image: cert1,
      title: "Incorporation Certificate",
      desc: "Incorporation of the company under the Companies Act, 2013",
    },
    {
      image: cert2,
      title: "Startup Recognition",
      desc: "Recognized as a Start-up under the Government Approved Scheme",
    },
    {
      image: cert3,
      title: "ISO 9001:2015 Certification",
      desc: "Certified for quality standards and reliable services",
    },
    {
      image: cert4,
      title: "ISO/IEC 17025:2017 Certification",
      desc: "Certified for quality standards and reliable services",
    },
    // {
    //   image: cert4,
    //   title: "ERTP Certification",
    //   desc: "Approved under ERTP by Govt. of Assam",
    // },
  ];

  return (
    <div className="d-flex justify-content-center">
      <div className="accreditation-section">
        <h2 className="ourteam-heading">Accreditations</h2>

        <div className="our-services-heading-container">
          <h1>Recognized for Quality & Standards</h1>
          <p>
            These official recognitions reflect our trust, authenticity, and
            compliance with standards.
          </p>
        </div>
        <div className="accreditation-grid">
          {cards.map((item, index) => (
            <div className="accreditation-card fade-up" key={index}>
              <div className="certificate-image-box">
                <img loading="lazy" decoding="async"
                  src={item.image}
                  alt={item.title}
                  className="certificate-img"
                />
              </div>
              <h3 className="certificate-title">{item.title}</h3>
              <p className="certificate-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Accreditations;
